import request from '@/utils/request'

export default {
    getExtPrice: function (traderId) {
        return request({
            url: 'grabOrder/getExtPrice',
            method: 'post',
            params: {
                traderId: traderId,
            },
        });
    },
    list: function (query) {
        return request({
            url: 'grabOrder/list',
            method: 'post',
            data: query,
        });
    },
    snapOrder: function (traderId, amount, type) {
        return request({
            url: 'grabOrder/snapOrder',
            method: 'post',
            params: {
                traderId: traderId,
                amount: amount,
                type: type,
            },
        });
    },
    completeOrder: function (id, completeImg1, completeImg2, phone, traderId) {
        return request({
            url: 'grabOrder/completeOrder',
            method: 'post',
            params: {
                id: id,
                completeImg1: completeImg1,
                completeImg2: completeImg2,
                phone: phone,
                traderId: traderId,
            },
        });
    },
    returnOrder: function (id, traderId) {
        return request({
            url: 'grabOrder/returnOrder',
            method: 'post',
            params: {
                id: id,
                traderId: traderId,
            },
        });
    },
    getStock: function () {
        return request({
            url: 'grabOrder/getStock',
            method: 'post',
        });
    },
    getRemainStock: function (type) {
        return request({
            url: 'grabOrder/getRemainStock',
            method: 'post',
            params: {
                type: type,
            },
        });
    },
}